module.exports = __webpack_public_path__ + "static/features-phone-mobile-2725e232cf9b66c98fbfa47a38e07203.png";